<input
  type="checkbox"
  class="appearance-none h-[30px] w-[30px] min-w-[30px] bg-white border border-[#9AA0A6] rounded-none cursor-pointer relative m-0
  shrink-0 checked:after:content-[''] checked:after:absolute checked:after:left-1/2 checked:after:top-[40%] checked:after:w-[10px]
  checked:after:h-[18px] checked:after:border-r-2 checked:after:border-b-2 checked:after:border-[#c03]
  checked:after:-translate-x-1/2 checked:after:-translate-y-1/2 checked:after:rotate-45"
  [checked]="checked"
  [disabled]="disabled"
  (change)="onInputChange($event)"
/>
